<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
        :loading="false"
        :hasDownload="true"
    >
      <template #subHeaderActions> 
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <DateRangePicker id="stat-daterangepicker" @update:date="handleRangeDate" />
          <OutlineButton btn-class="btn-sm" icon-class="fas fa-download fs-3" type="primary" btn-text="button.download" @click="downloadView" :isLoading="isLoadingDownload"/>
        </div>
      </template>
      
      <template #layoutContent>
        <CrmEstimateStatusTurnover :load-stats="loadWidgetStatData" :title="$t('devis.devis') " id="devis" />
 
        <div class="row g-xl-10 mb-5">
          <div class="col-lg-6 col-xl-6 col-xxl-6 mb-5 mb-xl-0">
            <CrmEstimateStatusTurnoverPercentage :load-stats="loadWidgetStatData" :title="$t('crm.statistics.sale_estimate_status') +'(%)'" id="sale_estimate_status" />
          </div>

          <div class="col-lg-6 col-xl-6 col-xxl-6 mb-5 mb-xl-0">
            <CrmEstimateSalesByPeriod :load-stats="loadWidgetStatData" :title="$t('crm.statistics.sale_estimate_validate') +'('+defaultCurrency?.symbol+')'" id="sale_estimate_validate" />
          </div>
        </div>

        <CrmTopOpportunitiesEstimateStat :load-stats="loadWidgetStatData" :title="$t('estimate.pipeline_generate') " id="pipeline_generate" /> 
      </template>
    </SubLayout>
  </template>
  <script setup>
  import {onMounted, ref, nextTick, shallowRef, computed, watch} from "vue";
  import {useStore} from "vuex";
  import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
  import i18n from '@/plugins/i18n';
  import DateRangePicker from "@/components/DateRangePicker.vue";
  import { useLocales } from "@/composables/locales";
  import OutlineButton from "@/components/OutlineButton";
  import CrmEstimateStatusTurnoverPercentage from "@/components/stats/widgets/CrmEstimateStatusTurnoverPercentage.vue";
  import CrmEstimateSalesByPeriod from "@/components/stats/widgets/CrmEstimateSalesByPeriod.vue";
  import CrmTopOpportunitiesEstimateStat from "@/components/stats/widgets/CrmTopOpportunitiesEstimateStat.vue";
  import CrmEstimateStatusTurnover from "@/components/stats/widgets/CrmEstimateStatusTurnover.vue";

  const {locale} = useLocales()
  const store = useStore()
  
  const title = ref( "navigation.statistics")
  const breadcrumbs = ref([
    {
      name: 'devis.devis',
      path: '/admin'
    }
  ])
  
  const query = ref({
    start_date: '',
    end_date: '',
    seller_id: '',
    contact_id: ''
  })
    

  const isLoadingDownload = ref(false)

  const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

  watch(() => query.value.contact_id, (value) => {
    loadData()
  })

  watch(() => query.value.seller_id, (value) => {
    loadData()
  })
  
  function handleRangeDate (range) {
    query.value.start_date = range.start_date
    query.value.end_date = range.end_date
    if(query.value.start_date && query.value.end_date) loadData()
  }

  async function loadWidgetStatData(params) {
    try {
      const res = await store.dispatch('statistics/loadStatistics', params)
      return res
    } finally {
    }
  }
  
  function loadData(){
    Promise.all([
      
      store.dispatch('company/generalInformation'),
    
    ]).then(() => {
    })
  }
  
  onMounted(() => {
    let start = moment().subtract(29, 'days');
    let end = moment();
    query.value.start_date = start.format('DD-MM-YYYY')
    query.value.end_date = end.format('DD-MM-YYYY')
  
    if(query.value.start_date && query.value.end_date){ 
      nextTick(() => {
        loadData();
      });
    }
  })

  function downloadView(){
    isLoadingDownload.value = true
    let data = {
      start_date: query.value.start_date,
      end_date: query.value.end_date,
      creator_id: query.value.seller_id,
      contact_id: query.value.contact_id
    }
    store.dispatch('statistics/getDownloadEstimateStatistics', data)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', i18n.global.t('devis.devis')+query.value.start_date+'.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.toastr['success'](i18n.global.t('notification.download_estimate'))
        })
        .catch(err => {
        }).finally(() => isLoadingDownload.value = false)
  }
  
 
  
  </script>
  